/**
 * HTML sanitization utility
 *
 * FSD: shared/lib
 * Wraps DOMPurify to prevent XSS in v-html bindings.
 */

import DOMPurify from 'dompurify';

export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html);
}
